import Jumbotron from '@/components/ui/box/Jumbotron';
import JumbotronDescription from '@/components/ui/box/JumbotronDescription';
import JumbotronPanel from '@/components/ui/box/JumbotronPanel';
import JumbotronTitle from '@/components/ui/box/JumbotronTitle';

import CSSModule from './AnnouncementDetailRestricted.module.scss';

const AnnouncementDetailRestricted: React.FC = () => (
  <div className={CSSModule.AnnouncementDetailRestricted}>
    <Jumbotron>
      <JumbotronPanel>
        <JumbotronTitle>お知らせ機能を利用できません</JumbotronTitle>
        <JumbotronDescription>
          契約手続きが未完了もしくは団体会員コード未登録のため利用できません。学校にお問い合わせください。
        </JumbotronDescription>
      </JumbotronPanel>
    </Jumbotron>
  </div>
);

export default AnnouncementDetailRestricted;
